import { useMemo } from 'react';
import { createResourceAtom } from 'lib/atoms';
import { createMutationAtom } from 'atoms/create-resource-atom';
import { createFileAtom, FileAtomState } from 'lib/atoms/file-atom';
import { atomWithStorage } from 'jotai/utils';
import {
  CompletionConfigurationResponse,
  DocumentResponse,
} from 'types/api-responses';

// Use the shared FileAtomState type as our DocumentFile type
export type DocumentFile = FileAtomState;

// Persists the selected document type across sessions
export const documentTypeAtom = atomWithStorage(
  'addDocumentModal.documentType',
  '',
  undefined,
  { getOnInit: true }
);

// Configuration options atom
export const useConfigurationOptionsAtom = (href?: string) =>
  useMemo(
    () => createResourceAtom<CompletionConfigurationResponse>(href),
    [href]
  );

// Use the shared file atom implementation
export const fileAtom = createFileAtom();

// Document submission atom
export const submitDocumentAtom = createMutationAtom<
  DocumentResponse,
  'document_uploads'
>();
